import { render, staticRenderFns } from "./StartUpFeatureTwo.vue?vue&type=template&id=db290860&"
import script from "./StartUpFeatureTwo.vue?vue&type=script&lang=js&"
export * from "./StartUpFeatureTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports